import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'gtd-ui-field-default-date-filter',
  templateUrl: './date-filter.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DateFilterComponent implements OnInit {
  @Input() data: string;
  mapping = {
    created_at: $localize`:@@common.created_at:Created At`,
    afm_date: $localize`:@@common.afm_date:AFM Date`,
  };

  ngOnInit() {
    if (this.data) {
      this.data = this.mapping[this.data] ?? this.data;
    }
  }
}
